let mapper_options = {
  endpoint: 'ad_run_tasks',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      ad_run: {
        foreignKey: 'ad_run_id',
        localField: 'ad_run'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('ad_run_task', mapper_options)
}